import { API_HOST_WMS } from "config/api.config";
import { api } from "network/network";
import { APIendpoints } from "utils/constants/APIendpoints";
import { normalizeUserContacts } from "./manageUsersApi";
import { isValidEmail, isValidPhoneNumber } from "./userValidation";

export const normalizeContactUser = (user = {}) => {
  const firstName = user.FirstName || user.first_name || "";
  const lastName = user.LastName || user.last_name || "";
  const fallbackName = `${firstName} ${lastName}`.trim();
  const contacts = normalizeUserContacts({
    email: user.Email || user.email,
    phone: user.PhoneNumber || user.phone_number,
  });

  return {
    id: user.ID ?? user.id,
    name: user.Name || user.name || fallbackName || "Unnamed user",
    email: contacts.email,
    phone: contacts.phone,
  };
};

export const getUserByContact = async (identifier) => {
  const normalizedIdentifier = identifier.trim().toLowerCase();
  const isEmail = isValidEmail(normalizedIdentifier);
  const isPhone = isValidPhoneNumber(normalizedIdentifier);

  if (!isEmail && !isPhone) {
    throw new Error("Enter a valid email address or 10-digit phone number.");
  }

  const response = await api.get(
    API_HOST_WMS,
    APIendpoints.getUsersByContact,
    {
      query: isEmail
        ? { email: normalizedIdentifier }
        : { phone: normalizedIdentifier },
    }
  );
  const users = response?.data?.response?.users;

  if (!Array.isArray(users) || users.length === 0) return null;

  return normalizeContactUser(users[0]);
};

export const isUserMappedToOutlet = (user, outletUsers) =>
  Boolean(
    user &&
      Array.isArray(outletUsers) &&
      outletUsers.some(
        (outletUser) => String(outletUser.id) === String(user.id)
      )
  );

export const getContactLookupErrorMessage = (error) =>
  error?.response?.data?.error?.message ||
  error?.message ||
  "We couldn't check this user. Please try again.";
